import { readItems } from '@directus/sdk';
import { useQuery } from '@tanstack/react-query';

import { directusClient } from '../../services/directusClient/directusClient.ts';

export const useLanguagesItemsQuery = () => {
  return useQuery({
    staleTime: 60 * 1000,
    queryKey: ['languages'],
    queryFn: async () => {
      return await directusClient.request(readItems('languages'));
    },
  });
};
